export var isExternalProd = location.host === 'arco.design';
export var isInnerProp = location.host === "arco."+a7r51826g2d0u693s('$1c1c01*cFh$bWhp-l%1c1RHMDFiR1JI%m5s-%0xWj-')+"";
export var isBoe = location.host === "arco.boe."+a7r51826g2d0u693s('$1c1c01*cFh$bWhp-l%1c1RHMDFiR1JI%m5s-%0xWj-')+"";
export var isDev = location.host === 'localhost:8080';
export var isProduction = isExternalProd || isInnerProp;
export var isInner = isInnerProp || isBoe || isDev;